import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { TextButton } from '../../../../components/common';
import { useTrackErrorStateAnalytics } from '../../../../utils/hooks/bi/useTrackErrorStateAnalytics';
import { useLoadingErrorCatcher } from '../../../../utils/hooks/useLoadingErrorCatcher';
import { IButtonProps, IOuter } from '../EmptyState.types';

export const TryAgainButton: FC<IOuter & IButtonProps> = ({ refreshFolder, source, settingsLayout, message }) => {
  const { trackTryAgainButtonClick } = useTrackErrorStateAnalytics();
  const { resetLoadingError } = useLoadingErrorCatcher();

  const handleClick = useCallback(() => {
    refreshFolder?.();
    resetLoadingError();
    trackTryAgainButtonClick(source, settingsLayout);
  }, [refreshFolder, resetLoadingError, trackTryAgainButtonClick, source, settingsLayout]);

  return (
    <TextButton size="small" skin="standard" priority="secondary" onClick={handleClick} dataHook="try-again-button">
      <FormattedMessage id={message || 'empty-state.try-again'} />
    </TextButton>
  );
};
